import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RadarGradeChart from "./RadarGradeChart";
import PieGradeChart from "./PieGradeChart";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SvgIcon from "@material-ui/core/SvgIcon";
import { FilterBar, SelectFilterBar } from "../infopage/detailpage";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.light
  },
  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "92%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  chart: {
    margin: "auto"
  },
  dialog: {
    width: "100%"
  },
  table: {
    width: "100%"
  },
  tableHead: {
    backgroundColor: theme.palette.secondary.light
  },
  tableCell: {
    color: theme.palette.common.white
  },

  tableHeadCell: {
    minWidth: "100px"
  }
}));
//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//正确错误图标
const rightIcon = (
  <SvgIcon
    nativecolor="white"
    style={{
      color: "green"
    }}
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </SvgIcon>
);
const wrongIcon = (
  <SvgIcon
    nativecolor="white"
    style={{
      color: "red"
    }}
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </SvgIcon>
);

function TestDetailTable(props) {
  const classes = useStyles();
  const { specification } = props;
  const tableHeadTitle = [
    { columnField: "rightAnswer", columnName: "正确答案" },
    { columnField: "studentAnswer", columnName: "学生作答" }
  ];

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          {tableHeadTitle.map(({ columnField, columnName }) => (
            <TableCell
              align="left"
              className={classes.tableHeadCell}
              key={columnField}
            >
              <Typography
                variant="subtitle1"
                color="textPrimary"
                className={classes.typography}
              >
                {columnName}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {specification.map(({ rightAnswer, studentAnswer }) => {
          return (
            <TableRow key={rightAnswer} hover>
              <TableCell component="th" scope="row">
                {rightAnswer}
              </TableCell>
              <TableCell align="left">
                <>
                  {studentAnswer ? studentAnswer : "未作答"}
                  {studentAnswer === rightAnswer ? rightIcon : wrongIcon}
                </>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

//Main Component显示构件测试的试卷详情
function TestDetailDialogButton(props) {
  const classes = useStyles();

  const [open, handleClickOpen, handleClose] = useDialog();

  const { buttonText, specification } = props;

  return (
    <>
      <Button onClick={handleClickOpen} color="secondary" component="span">
        {buttonText}
      </Button>

      <Dialog open={open} onClose={handleClose} className={classes.dialog}>
        <DialogContent className={classes.dialog}>
          <Grid
            container
            component={Paper}
            className={classes.paper}
            justify="center"
          >
            <Grid item xs={12}>
              <Typography
                variant="h5"
                gutterBottom
                color="secondary"
                className={classes.typography}
              >
                构件辨识实验详情
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TestDetailTable specification={specification} />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TestDetailDialogButton;
